module.exports = __webpack_public_path__ + "img/美妆-5.262ad8d3.png";